import { render, staticRenderFns } from "./Acertos.vue?vue&type=template&id=49faaf78&scoped=true"
import script from "./Acertos.vue?vue&type=script&lang=js"
export * from "./Acertos.vue?vue&type=script&lang=js"
import style0 from "./Acertos.vue?vue&type=style&index=0&id=49faaf78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49faaf78",
  null
  
)

export default component.exports